import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { logger } from 'src/lib/utils/logging';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';



@Injectable()
export class ErrorResponseInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(response => this.handleError(request, response))
    );
  }

  handleError(request: HttpRequest<any>, response: HttpErrorResponse): Observable<any> {
    const { error } = response;
    const throwable = this.isMessageList(error) ? error : response;

    logger.warn('[ ErrorResponseInterceptor ] handleError :', throwable);

    return throwError(throwable);
  }

  isMessageList(error: any): boolean {
    return Array.isArray(error) &&
           error.length > 0 &&
           error.every(o => typeof o.code === 'string' || typeof o.rule === 'string');
  }
}
